import ProductList from "../../components/product/list";
import useAppNavigate from "../../components/router/use-app-navigate";
import SignUpLayout from "../../components/signup/layout";
import { useLocation } from "react-router-dom";
export default function SignUpPurchase() {
  let navigate = useAppNavigate();
  const location = useLocation();
  return (
    <SignUpLayout
      step={location.pathname === "/signup/ngn/purchase" ? 5 : 4}
      type={location.pathname === "/signup/ngn/purchase" ? 40: 0}
      steps={
        location.pathname === "/signup/ngn/purchase" ? [4, 5, 6] : [3, 4, 5]
      }
    >
      <ProductList
        isShop={false}
        onSuccess={(id) =>
          location.pathname === "/signup/ngn/purchase"
            ? navigate(`/signup/ngn/payment/${id}`)
            : navigate(`/signup/payment/${id}`)
        }
      />
    </SignUpLayout>
  );
}
